import React, { Component } from 'react'
import { Button } from 'semantic-ui-react'

export default class Submit extends Component {
  state = {
    open: false,
  }

  render() {
    let { size = 'tiny', prompt = false, ...props } = this.props
    let { open } = this.state

    if (!prompt) return <Button {...props} size={size} type="submit" />

    if (!open)
      return (
        <div className="submit-prompt">
          <Button {...props} size={size} as="a" onClick={e => e.preventDefault() & this.setState({ open: true })} />
        </div>
      )

    return (
      <div className="submit-prompt submit-prompt--question">
        <b>Oletko varma?</b>{' '}
        <button className="button-plain" type="submit">
          Kyllä
        </button>
        {' / '}
        <button className="button-plain" onClick={e => e.preventDefault() & this.setState({ open: false })}>
          En
        </button>
      </div>
    )
  }
}
